import {Location} from '@angular/common';
import {HttpHeaders} from '@angular/common/http';
import {Component} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '@drl/core/api/api.service';
import {User} from '@drl/core/auth/models/user.model';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {environment} from '@drl/env/environment';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

import {AuthService} from '../core/auth/auth.service';
import {RouteComponentBase} from '../core/route-component-base';
import {UserSessionStoreService as StoreService} from '../core/store/user-session-store.service';
import {ChangePasswordAdapter} from './adapters/change-password-adapter.service';
import {ChangePasswordCommand} from './commands/change-password.command';
import {ChangePasswordModel} from './models/change-password.model';
import { EncryptionService } from '@drl/core/auth/encryption.service';
import { EncryptPayloadModel } from '@drl/core/auth/models/encrpt-payload.model';
import { EncrptPayloadAdapter } from '@drl/core/auth/adapters/encrpt-payload-adapter.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: [],
})
export class ChangePasswordComponent extends RouteComponentBase {
  constructor(
    protected readonly route: ActivatedRoute,
    private readonly store: StoreService,
    protected readonly location: Location,
    private readonly apiService: ApiService,
    private readonly changePasswordAdapter: ChangePasswordAdapter,
    private readonly router: Router,
    private readonly toastrService: ToastrService,
    private readonly authService: AuthService,
    protected readonly translateSvc: IpsTranslateService,
    private encryptService: EncryptionService,
    private readonly encryptAdapter: EncrptPayloadAdapter,
  ) {
    super(route, location);
    this.tenantName = this.store.getTenantName();

    this.translate = this.translateSvc.translate;
  }

  translate: TranslateService;
  passwordMismatch = false;
  tenantName: string;
  loading = false;
  user: ChangePasswordModel = {
    username: '',
    password: '',
    confirmPassword: '',
    newPassword: '',
  };
  currentUser: User;
  submitted: boolean;
  rememberMe: boolean;
  brand = environment.brand;
  logo = `/assets/logo-${environment.brand.toLocaleLowerCase()}.png`;
  ngOnInit() {
    if(this.store.getWhiteLabelled() && this.store.getTenantLogo()){
      this.logo = this.store.getTenantLogo();
    }
    else{
      this.logo = `/assets/logo-${environment.brand.toLocaleLowerCase()}.png`;
    }
    this.currentUser = this.store.getUser();
  }

  passwordMatch() {
    if (this.user.newPassword !== this.user.confirmPassword) {
      this.passwordMismatch = true;
    } else {
      this.passwordMismatch = false;
    }
  }

  updatePassword(form: NgForm): void {
    if (form.invalid) {
      return;
    }

    if (this.user.newPassword !== this.user.confirmPassword) {
      return;
    }

    this.loading = true;
    const command: ChangePasswordCommand<EncryptPayloadModel> = new ChangePasswordCommand(
      this.apiService,
      this.encryptAdapter,
    );

    const userInStore = this.store.getUser();

    this.user.username = userInStore.username;
    const changePassModel={
      username: this.user.username,
      password: this.user.newPassword,
      oldPassword: this.user.password,
    };
    
    const encrpted = this.encryptService.encryptData(JSON.stringify(changePassModel));
    command.parameters = {
      data: {data:encrpted},
      headers: new HttpHeaders().set(
        'refresh-token',
        this.store.getRefreshToken(),
      ),
    };

    this._subscriptions.push(
      command.execute().subscribe(
        res => {
          this.authService.logout();
        },
        err => {
          this.loading = false;
        },
      ),
    );
  }
}
